'use strict';
/* Controllers for the autoremind.patients feature */
/**
 * Main screen controller for the logs screen
 */
angular.module('autoremind.admin', ['angularFileUpload'])
    .controller('autoremind.admin.ScreenController', 
// Setup dependencies
['$scope', '$http', 'logger', 'Upload', 'dialogs', 'audioServiceDowngraded',
    function ($scope, $http, logger, $upload, dialogs, audioServiceDowngraded) {
        // Initialize
        logger.info('In autoremind.admin.ScreenController');
        //https://github.com/danialfarid/angular-file-upload
        //    $scope.fileData = { "files": [ {"name": "a", "soundid": "111"}, {"name": "b", "soundid": "222"}] };
        $scope.fileData = { "files": [] };
        $scope.viewModel = {};
        $scope.viewModel.files = [];
        $scope.onFileSelect = function ($files) {
            //$files: an array of files selected, each file has name, size, and type.
            //$scope.fileData = { "files": [ ] };
            //$scope.fileData.files = [];
            // Clear old list (TODO: consider if we can append any new files added)
            $scope.viewModel.files = [];
            for (var i = 0; i < $files.length; i++) {
                var file = $files[i];
                file.displayProgress = false;
                $scope.viewModel.files[i] = file;
                logger.debug('File: name=' + file.name + '  size=' + Math.floor(file.size / 1024));
                if (file.size > 65536) {
                    dialogs.error('Error', 'The file [' + file.name + '] is probably too big (' + Math.floor(file.size / 1024) + ' kb). ' +
                        'Files bigger than 65 kb may cause problems. Probably too high sample rate!');
                }
            }
        };
        $scope.currentRow = 0;
        $scope.uploadSelected = function () {
            $scope.currentRow = 0;
            $scope.uploadRow();
        };
        $scope.uploadRow = function () {
            var file = $scope.viewModel.files[$scope.currentRow];
            file.displayProgress = true;
            logger.debug('Uploading file ' + file.name + '(' + $scope.currentRow + ')...');
            //TODO: Skip if unselected
            $scope.upload = $upload.upload({
                url: '',
                // method: POST or PUT,
                // headers: {'header-key': 'header-value'},
                // withCredentials: true,
                //data: {files: $scope.viewModel.files,
                //},
                file: file,
            }).progress(function (evt) {
                file.progress = parseInt(100.0 * evt.loaded / evt.total);
                //$scope.viewModel.files[i].progress = parseInt(100.0 * evt.loaded / evt.total);
                //console.log('percent: ' + parseInt(100.0 * evt.loaded / evt.total));
            }).success(function (response, status, headers, config) {
                // file is uploaded successfully
                //TODO: Add sample rate, bit rate, etc. in backend and let frontend report errors
                //TODO: Handle error messages
                file.displayProgress = false;
                file.soundid = response.files[0].soundid;
                file.serverModified = response.files[0].modified;
                file.error = response.files[0].error;
                logger.debug('Upload file ' + file.name + '(' + $scope.currentRow + ') done...');
                $scope.currentRow++;
                if ($scope.currentRow < $scope.viewModel.files.length)
                    $scope.uploadRow();
                //$scope.viewModel.files[i].fileName = response.name;
                //console.log(data);
            }).error(function () {
                logger.debug('Upload failed for file ' + file.name + '(' + $scope.currentRow + ')!');
                $scope.currentRow++;
                file.displayProgress = false;
                if ($scope.currentRow < $scope.viewModel.files.length)
                    $scope.uploadRow();
            });
        };
        $scope.playingNow = -1;
        $scope.isPlaying = false;
        $scope.play = function ($event, id) {
            if (!angular.isDefined(id) || id === '') {
                return;
            }
            $scope.isPlaying = true;
            $scope.playingNow = id;
            // to stop previous audio
            if (audioServiceDowngraded.audio !== undefined) {
                audioServiceDowngraded.stopAudio();
            }
            var audio = new Audio();
            audio.src = audioServiceDowngraded.getUrlForSoundId() + id;
            audioServiceDowngraded.setAudio(audio);
            audioServiceDowngraded.playAudio();
        };
        $scope.stop = function () {
            $scope.playingNow = -1;
            $scope.isPlaying = false;
            audioServiceDowngraded.stopAudio();
        };
        $scope.patient =
            {
                "firstname": "Jane",
                "lastname": "Doe",
                "email": "john@doe.com",
                "mobile": "252-5555"
            };
        //TODO: Call this once on controller init and just check a value
        function isTouchDevice() {
            return !!('ontouchstart' in window);
        }
    }]);
angular.module('autoremind.admin')
    .controller('autoremind.admin.TableController', 
// Setup dependencies
['$scope', '$http', 'logger', '$enhancedHttp',
    function ($scope, $http, logger, $enhancedHttp) {
        // Initialize
        $scope.patients = [];
        //$scope.url = 'http://localhost:8080/ar2proto/server/server.php?username=jb&password=test&test=list.json';
        //$scope.url = '../server/server.php?username=jb&password=test&command=getPatientList';
        $scope.url = 'patients/';
        /*
         *
         */
        $scope.fetch = function () {
            logger.info('TableController.fetch()');
            $scope.code = null;
            $scope.response = null;
            $enhancedHttp({ method: 'GET', url: $scope.url })
                .then(function (data, status) {
                $scope.status = status;
                $scope.data = data;
                $scope.patients = data;
                logger.debug('DATA: ' + data);
            }, function (data, status) {
                logger.error('ERROR: ' + data);
                $scope.data = data || "Request failed";
                $scope.status = status;
            });
        };
    }]);
//# sourceMappingURL=voice.controllers.js.map